import * as React from "react"
import {SelectSeeker} from "@ui-seeker/core";

import { lostBuyBoxReason } from "@signals";

export const OPTIONS = [
	{ label: 'Price', value: 1 },
	{ label: 'Price + Shipping', value: 2 },
	{ label: 'Delivery Date', value: 3 },
	{ label: 'No 1P Offer', value: 4 },
    { label: 'Unknown', value: 0 },
	{ label: 'Craped', value: -1 }
]

export default function DIPLostReasonSelect({ ...props }) {
	return <SelectSeeker
		multiple
		options={OPTIONS}
		label="Lost Reason"
		value={lostBuyBoxReason.value}
		onChange={e => lostBuyBoxReason.value = e.target.value}
		{...props}
	/>
}